<template>
  <v-card
    v-if="!closed"
    flat
    class="background-card d-flex align-center position-relative"
  >
    <v-btn
      icon
      small
      style="z-index: 1"
      class="close-btn neutral-40-light--text"
      @click="closeBanner"
      aria-label="Fechar banner"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <img
      :src="bannerImg"
      alt="Banner Analytics"
      width="355"
      height="199"
      class="rounded"
    />

    <div class="flex-grow-1">
      <span>
        <v-tag>
          {{ $t('message.pages.analyticsV3.resume.new') }}
        </v-tag>
      </span>

      <p class="body-bold-larger brand-0--text mb-1 mt-4">
        Panda Analytics
      </p>

      <p class="body-bold-large brand-0--text mb-1">
        {{ $t('message.pages.analyticsV3.resume.subtitle') }}
      </p>

      <p class="body-regular-small neutral-20-dark--text mt-4 text-break">
        {{ $t('message.pages.analyticsV3.resume.description') }}
      </p>
    </div>
  </v-card>
</template>

<script>
const LOCAL_STORAGE_KEY = 'analyticsv3-banner'

export default {
  name: 'AnalyticsBanner',
  data() {
    return {
      closed: false,
    }
  },
  computed: {
    bannerImg() {
      return this.$vuetify.theme.dark
        ? require('@/assets/banner-img-analytics-dark.png')
        : require('@/assets/banner-img-analytics.png')
    },
  },
  created() {
    this.closed = localStorage.getItem(LOCAL_STORAGE_KEY) === 'true'
  },
  methods: {
    closeBanner() {
      this.closed = true
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true')
    },
  },
}
</script>

<style lang="scss" scoped>
.background-card {
  padding: 16px;
  gap: 40px;
  border-radius: 8px;
  background: varFigma(neutral-95-lightest) !important;
  position: relative;
}

.text-break {
  white-space: pre-line;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  color: varFigma(neutral-50-dark);
  z-index: 10;
}
</style>
